
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Regan_classification_of_ulnar_coronoid_process_fractures_of_the_elbow',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Regan_classification_of_ulnar_coronoid_process_fractures_of_the_elbow.vue